var $f3a9d466bd3005e4$exports = {};
$f3a9d466bd3005e4$exports = {
    "maximum": `Maximum`,
    "minimum": `Minimum`
};


export {$f3a9d466bd3005e4$exports as default};
//# sourceMappingURL=nl-NL.module.js.map
